export const types = <const>{
	mutations: {
		SPLIT_CUSTOMER_LIST_MAPPER: 'SPLIT_CUSTOMER_LIST_MAPPER',
		SPLIT_CUSTOMER_SELECT_MAPPER: 'SPLIT_CUSTOMER_SELECT_MAPPER',
	},
};